
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-footer',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div class="px-6 py-4 bg-white border-t border-gray-200 text-center md:text-left">
            <p class="text-sm text-gray-500">
                © 2026 <span class="font-semibold text-primary-green">AWH</span>. Powered by PT. AWH Inti Nusantara.
            </p>
        </div>
    `
})
export class FooterComponent {}
